import { Outlet } from 'react-router'
import { Box } from '@mui/material'
import { NavigationView } from 'Features/Projects/Navigation.view'

/**
 * Sidebar beside the content. It fills the shell's content column instead of
 * taking a fixed `80vh`, so it ends at the footer at any window height.
 */
export const ProjectLayout = () => {
  return (
    <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
      <NavigationView />
      <Box sx={{ display: 'flex', flex: 1, minWidth: 0, overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  )
}
